import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const stats = [{
  number: '500+',
  label: 'Emprendedores transformados'
}, {
  number: '8',
  label: 'Años de experiencia'
}, {
  number: '3',
  label: 'Plataformas propias'
}, {
  number: '$2M+',
  label: 'Generados por clientes'
}];
export function WhoYouAre() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 md:py-32 bg-white" data-id="element-339">
      <div className="max-w-6xl mx-auto px-6" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-341">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-342">
            Quién soy
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6" data-id="element-343">
            Fundador. Mentor. Arquitecto de transformación.
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-2xl mx-auto leading-relaxed" data-id="element-344">
            Mi trabajo no es enseñarte a vender — es ayudarte a convertirte en
            quien necesitas ser para construir lo que deseas.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-345">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: 'easeOut'
        }} className="text-center p-6 md:p-8 bg-cream/50 rounded-2xl" data-id="element-346">
              <span className="block font-serif text-4xl md:text-5xl text-gold mb-2" data-id="element-347">
                {stat.number}
              </span>
              <span className="font-sans text-sm text-charcoal-mid" data-id="element-348">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}